export type Listener<T> = (payload: T) => void;

export type EventType = "error" | "warning" | "info";

export class EventEmitter<T extends Partial<Record<EventType, unknown>>> {
  private listeners: { [K in keyof T]?: Listener<T[K]>[] } = {};

  on<K extends keyof T>(event: K, listener: Listener<T[K]>) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event]!.push(listener);
  }

  off<K extends keyof T>(event: K, listener: Listener<T[K]>) {
    this.listeners[event] = this.listeners[event]?.filter(
      (l) => l !== listener
    );
  }

  emit<K extends keyof T>(event: K, payload: T[K]) {
    this.listeners[event]?.forEach((listener) => listener(payload));
  }
}
